import React from 'react';
import { useTranslation } from 'react-i18next';
import RttRoundedIcon from '@mui/icons-material/RttRounded';

import scss from './EmptyGeneratedMessagesDisclaimer.module.scss';

function EmptyGeneratedMessagesDisclaimer() {
  const { t } = useTranslation('activ8');

  return (
    <div className={scss.wrapper}>
      <RttRoundedIcon className={scss.icon} />
      <span className={scss.title}>{t('noGeneratedMessagesYet')}</span>
      <span className={scss.description}>{t('emptyGeneratedMessagesDescription')}</span>
    </div>
  );
}

export default EmptyGeneratedMessagesDisclaimer;
